export type AgingBucket =
  | 'current'
  | 'days1to30'
  | 'days31to60'
  | 'days61to90'
  | 'days91plus';

export const AGING_BUCKETS: AgingBucket[] = [
  'current',
  'days1to30',
  'days31to60',
  'days61to90',
  'days91plus',
];

const MS_PER_DAY = 24 * 60 * 60 * 1000;

/**
 * Classify an invoice into the aging bucket column it should appear in,
 * given its due date and the report's as-of date. Bucket boundaries match
 * QuickBooks AgedReceivables convention (1–30 inclusive of 30; 31–60
 * inclusive of 60; etc.).
 */
export function getBucketForInvoice(dueDate: string, asOfDate: string): AgingBucket {
  const due = Date.parse(`${dueDate}T00:00:00Z`);
  const asOf = Date.parse(`${asOfDate}T00:00:00Z`);
  const daysOverdue = Math.floor((asOf - due) / MS_PER_DAY);
  if (daysOverdue <= 0) return 'current';
  if (daysOverdue <= 30) return 'days1to30';
  if (daysOverdue <= 60) return 'days31to60';
  if (daysOverdue <= 90) return 'days61to90';
  return 'days91plus';
}
